import { REPORT_TYPE_CHIP_CLASSES, REPORT_TYPE_OPTIONS, labelFor } from "@components/Prompts/constants";
import { REPORT_TYPE_ABBREVIATIONS, type ReportTypeValue } from "@pages/Templates/constants";

export function ReportTypeChips({ reportTypes }: { reportTypes: ReportTypeValue[] }) {
  if (reportTypes.length === 0) {
    return <span className="shrink-0 text-xs italic text-text-tertiary">Untagged</span>;
  }
  return (
    <span className="inline-flex shrink-0 gap-1">
      {reportTypes.map((t) => (
        <span
          key={t}
          title={labelFor(t)}
          className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${
            REPORT_TYPE_CHIP_CLASSES[t] ?? "border-border-subtle bg-bg-default text-text-secondary"
          }`}
        >
          {REPORT_TYPE_ABBREVIATIONS[t] ?? t}
        </span>
      ))}
    </span>
  );
}

interface ReportTypeCheckboxesProps {
  value: ReportTypeValue[];
  onChange: (next: ReportTypeValue[]) => void;
}

/** Required multi-select used wherever a prompt is created or edited. */
export function ReportTypeCheckboxes({ value, onChange }: ReportTypeCheckboxesProps) {
  const toggle = (t: ReportTypeValue) => {
    const next = value.includes(t) ? value.filter((v) => v !== t) : [...value, t];
    // Keep enum order so saved tags are stable regardless of click order.
    onChange(REPORT_TYPE_OPTIONS.filter((o) => next.includes(o)));
  };

  return (
    <div className="flex flex-col gap-1">
      <span className="text-sm font-medium text-text-secondary">
        Report types <span className="text-text-error-primary">*</span>
        <span className="ml-2 text-xs font-normal text-text-tertiary">which report types this prompt is valid for</span>
      </span>
      <div className="flex flex-wrap gap-4">
        {REPORT_TYPE_OPTIONS.map((t) => (
          <label key={t} className="flex cursor-pointer items-center gap-2 text-sm text-text-primary">
            <input
              type="checkbox"
              checked={value.includes(t)}
              onChange={() => toggle(t)}
              className="h-4 w-4 rounded border-border-medium text-rio-600"
            />
            {labelFor(t)}
          </label>
        ))}
      </div>
    </div>
  );
}
